export type PayloadMessage = {
  _id?: string;
  tokenChat: string;
  tokenSessionUser: string;
  senderName: string;
  senderId: string;
  userKey?: string;
  receiverName: string;
  receiverId: string;
  messageType: string;
  createdAt?: number;
  text?: string;
  image?: { url: string; externalUrl?: string; mimeType: string };
  video?: { url: string; externalUrl?: string; mimeType: string };
  document?: { url: string; externalUrl?: string; mimeType: string };
  audio?: { url: string; externalUrl?: string; mimeType: string };
};

export enum PayloadMessageType {
  TEXT = "text",
  IMAGE = "image",
  VIDEO = "video",
  AUDIO = "audio",
  DOCUMENT = "document",
}
